module.exports = __webpack_public_path__ + "img/i_list_info_chart.84d4ce41.svg";